export const moduleNamespace = 'entitlements';
export const routeNamespace = '/admin';
export const mapNamespace = '/map';
